import RoutesConstant from '../constants/routes';
import PageLayoutEnum from '../enum/pageLayout';
import Admin from '../pages/Admin/Admin';
import FailedOrder from '../pages/FailedOrder/FailedOrder';
import FailedOrderReport from '../pages/FailedOrder/FailedOrderReport';
import OperationsReport from '../pages/Operation/OperationReport';
import OperationsConsildatedScreen from '../pages/Operation/OperationsConsolidated';
import OperationRaw from '../pages/Operation/OperationsRaw';
import Outlet from '../pages/Outlet/Outlet';
import BulkOutletSync from '../pages/Outlet/OutletSync/BulkOutletSync';

export const getCommonRoutes = (permissionObj) => {
  return [
    {
      path: RoutesConstant.FAILED_ORDERS,
      component: FailedOrder,
      componentProps: {
        layout: PageLayoutEnum.LISTING,
      },
      showRoute: permissionObj.read,
    },
    {
      path: RoutesConstant.FAILED_ORDER_REPORT,
      component: FailedOrderReport,
      componentProps: {
        layout: PageLayoutEnum.LISTING,
      },
      showRoute: permissionObj.read,
    },
    {
      path: RoutesConstant.OPS_RAW,
      component: OperationRaw,
      componentProps: {
        layout: PageLayoutEnum.LISTING,
      },
      showRoute: permissionObj.read,
    },
    {
      path: RoutesConstant.OPS_CONSOLIDATED,
      component: OperationsConsildatedScreen,
      componentProps: {
        layout: PageLayoutEnum.LISTING,
      },
      showRoute: permissionObj.read,
    },
    {
      path: RoutesConstant.OPS_REPORT,
      component: OperationsReport,
      componentProps: {
        layout: PageLayoutEnum.LISTING,
      },
      showRoute: permissionObj.admin, // only admin access
    },
    {
      path: RoutesConstant.OUTLETS,
      component: Outlet,
      componentProps: {
        layout: PageLayoutEnum.LISTING,
      },
      showRoute: permissionObj.read,
    },
    {
      path: RoutesConstant.BULK_OUTLET_SYNC,
      component: BulkOutletSync,
      componentProps: {
        layout: PageLayoutEnum.LISTING,
      },
      showRoute: permissionObj.read,
    },
    {
      path: RoutesConstant.ADMIN,
      component: Admin,
      componentProps: {
        layout: PageLayoutEnum.LISTING,
      },
      showRoute: permissionObj.admin,
    },
  ];
};
